import React from "react";
import Common from "../../../Common";

class EffortCellEditor extends Common {
  constructor(props) {
    super(props);
    this.state = {
      values: {}, // Keeps track of current input values
    };
    this.containerRef = React.createRef() // Added ref for the parent container
  }

  getValue = () => {
    const { colDef } = this.props;
    const column = colDef?.field;

    // Return the final value to the grid
    return this.state.values[column] || this.props.value;
  };

  componentDidMount() {
    const { colDef, value } = this.props;

    // Initialize state with the current cell value
    this.setState({
      values: {
        [colDef?.field]: value || {},
      },
    })
  }

  componentWillUnmount() {
    // Update the data when component is about to unmount
    this.updateCellData()
  }

  // Extract update logic to a separate method to avoid duplication
  updateCellData = () => {
    const { colDef, node, api, onUpdateServer } = this.props
    const column = colDef?.field

    // Finalize and update the cell value
    const updatedValues = this.state.values[column] || {}
    node.setDataValue(column, updatedValues)

    // Optionally, call the API after editing completes
    if (onUpdateServer) {
      onUpdateServer(node.data) // Send the updated row data to the server
    }

    // Refresh the grid
    api.refreshCells({ rowNodes: [node] })
  }

  handleBlur = (event) => {
    const { stopEditing } = this.props

    // Check if focus is switching between inputs
    if (
      event.relatedTarget?.name === "effort_in_days" ||
      event.relatedTarget?.name === "effort_in_hours" ||
      this.containerRef.current?.contains(event.relatedTarget)
    ) {
      return // Prevent editing from stopping prematurely
    }

    // Update the cell data
    this.updateCellData()

    // Stop editing
    stopEditing()
  }

  handleChange = (evt) => {
    const { name, value } = evt.target
    const { colDef, node } = this.props

    const column = colDef?.field
    if (!/^\d*$/.test(value)) {
      return
    }

    if (!column) {
      console.error("Column field is not defined.")
      return
    }

    const currentValues = this.state.values[column] || {}

    if (name === "effort_in_days" && value >= 10000) {
      return
    }
    if (name === "effort_in_hours" && value > 8) {
      return
    }
    const updatedValues = {
      ...currentValues,
      [name]: Number(value),
    }

    // Calculate total hours
    updatedValues.total_hours =
      Number((updatedValues.effort_in_days || 0) * 1) * 8 + Number((updatedValues.effort_in_hours || 0) * 1)

    // Set effort based on options (if provided)
    const options = colDef.options
    if (options) {
      for (const key in options) {
        if (updatedValues.total_hours >= options[key]?.total_hours) {
          updatedValues.effort = key
        }
      }
    }

    // Update the state with the new values
    this.setState((prevState) => ({
      values: {
        ...prevState.values,
        [column]: updatedValues,
      },
    }))
  }

  render() {
    const { colDef } = this.props
    const columnValues = this.state.values[colDef?.field] || {}

    return (
      <div
        style={{ display: "flex", gap: "8px", flex: 1 }}
        ref={this.containerRef} // Add the ref to the parent div
      >
        <input
          type="number"
          name="effort_in_days"
          className="form-control"
          value={columnValues.effort_in_days || ""}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          onKeyDown={(e) => {
            // Allow only numbers and control keys
            if (
              !/^[0-9]$/.test(e.key) && // Allow digits
              e.key !== "Backspace" && // Allow Backspace
              e.key !== "ArrowLeft" && // Allow navigation keys
              e.key !== "ArrowRight"
            ) {
              e.preventDefault();
            }
          }}
          autoFocus
        />
        <input
          type="number"
          name="effort_in_hours"
          className="form-control"
          value={columnValues.effort_in_hours || ""}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
          onKeyDown={(e) => {
            // Allow only numbers and control keys
            if (
              !/^[0-9]$/.test(e.key) && // Allow digits
              e.key !== "Backspace" && // Allow Backspace
              e.key !== "ArrowLeft" && // Allow navigation keys
              e.key !== "ArrowRight"
            ) {
              e.preventDefault();
            }
          }}
        />
      </div>
    );
  }
}

export default EffortCellEditor;
